// extracted by mini-css-extract-plugin
module.exports = {"panel":"resource-not-found_panel__1NS_Q","error-code":"resource-not-found_error-code__39UL3","error-message":"resource-not-found_error-message__3Jg8d"};